import { render, staticRenderFns } from "./orgTree.vue?vue&type=template&id=2bfa22e4&scoped=true"
import script from "./orgTree.vue?vue&type=script&lang=js"
export * from "./orgTree.vue?vue&type=script&lang=js"
import style0 from "./orgTree.vue?vue&type=style&index=0&id=2bfa22e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfa22e4",
  null
  
)

export default component.exports